/**
 * Словари подкатегорий декоров — раздельно для трёх kind'ов (P-033).
 *
 * Источник истины: `docs/operations/decors-base-schema.md` (xlsx канон).
 * Используются:
 *   - в Zod-схемах FacadeSubcategorySchema / CountertopSubcategorySchema /
 *     PanelSubcategorySchema (`contracts/decors.ts`);
 *   - в UI-фильтрах Экрана 2.2.1 (Phase 5);
 *   - в адаптерах импорта из CSV (Phase 3).
 *
 * 3 раздельные accessor-функции — следствие P-033 / ESLint правила
 * `no-shared-decor-kind-handlers`. Общий `getSubcategories(kind)` запрещён.
 */

// xlsx Лист «Фасады»: МДФ Пленка / МДФ ламинированный.
// «МДФ Пленка» = реальная папка `База/Фасады ПВХ` (бренды AIF, EMC, Kira).
// «МДФ ламинированный» = реальные папки `Фасады МДФ ALVIC` и `Фасады МДФ CLEAF`.
// «МДФ Краска» УБРАНА (ADR-0056): данных 0, это отдельная функция Главной (Блок 3,
// подбор краски), не декор-подкатегория фасадов.
export const FACADE_SUBCATEGORIES = Object.freeze(['МДФ Пленка', 'МДФ ламинированный'] as const);
export type FacadeSubcategory = (typeof FACADE_SUBCATEGORIES)[number];

// xlsx Лист «Столешницы»: 4 непустые подкатегории.
// Реальные папки: `Столешницы ЛДСП`, `HPL`, `Столешница Камень/Камень Interstone/...`
// (в последней структура папок не 1:1 соответствует «акрил/кварц» — адаптер
// импорта Phase 3 маппит по бренду).
// «Литой камень» УБРАНА (ADR-0056): данных 0 (и единственный бренд Marmarit — 0 SKU).
export const COUNTERTOP_SUBCATEGORIES = Object.freeze([
  'Столешницы ЛДСП',
  'Столешницы HPL',
  'Камень акрил',
  'Камень кварц',
] as const);
export type CountertopSubcategory = (typeof COUNTERTOP_SUBCATEGORIES)[number];

// xlsx Лист «Корпус (ЛДСП)»: 2 подкатегории (ЛДСП и ЛДСП влагостойкая).
// «ЛДСП» = реальная папка `База/ЛДСП готов` (14 брендов).
// «ЛДСП влагостойкая» — отдельная подкатегория с подмножеством брендов (5 из 14)
// и теми же типами декоров. См. ADR-обсуждение в `decors-base-schema.md`.
export const PANEL_SUBCATEGORIES = Object.freeze(['ЛДСП', 'ЛДСП влагостойкая'] as const);
export type PanelSubcategory = (typeof PANEL_SUBCATEGORIES)[number];

export function getFacadeSubcategories(): readonly FacadeSubcategory[] {
  return FACADE_SUBCATEGORIES;
}

export function getCountertopSubcategories(): readonly CountertopSubcategory[] {
  return COUNTERTOP_SUBCATEGORIES;
}

export function getPanelSubcategories(): readonly PanelSubcategory[] {
  return PANEL_SUBCATEGORIES;
}
